/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "concierge-71a5d04b--sprite",
  "use": "concierge-71a5d04b--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"concierge-71a5d04b--sprite\"><rect width=\"36\" height=\"36\" fill=\"none\" /><g transform=\"translate(4.988 4.697)\"><g transform=\"translate(1 1.997)\"><path d=\"M3.477,17.3v1h20v-1a9.941,9.941,0,0,0-9-10v-2c.61-.346,1-.247,1-1a2,2,0,0,0-4,0,2.423,2.423,0,0,0,1,2v1A9.933,9.933,0,0,0,3.477,17.3Z\" transform=\"translate(-0.965 -1.997)\" fill=\"currentColor\" /><path d=\"M25.512,20.986a.988.988,0,0,0-1-1h-22c-.562,0-2,.438-2,1v2c0,.562,1.438,1,2,1h22a.988.988,0,0,0,1-1Z\" transform=\"translate(-1 -1.681)\" fill=\"currentColor\" /></g></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
